export enum RolesDrawerType {
  Create = 'create',
  Edit = 'Edit',
  View = 'view',
}

export enum RbacRoleObjectKey {
  // studio management
  StudioDelete = 'studioDelete',
  StudioPut = 'studioPut',

  // game management
  GameCreate = 'gameCreate',
  GameDelete = 'gameDelete',
  GamePut = 'gamePut',
  EditSystemSettings = 'EditSystemSettings',

  // organization management
  RoleCreate = 'roleCreate',
  RoleDelete = 'roleDelete',
  UserGroupCreate = 'userGroupCreate',
  UserGroupDelete = 'userGroupDelete',
  MemberInvite = 'memberInvite',
  MemberRemove = 'memberRemove',

  // env management
  EnvCreate = 'envCreate',
  EnvDelete = 'envDelete',
  EnvSync = 'envSync',
  EnvView = 'AuditHubTaskView',

  // fee center
  FeeCenterEdit = 'feeCenterEdit',
  FeeCenterView = 'feeCenterView',

  // 工作室认证
  StudioAuthentication = 'studioAuthentication',

  // open/stop service
  EnvironmentServerStartAndStop = 'EnvironmentServerStartAndStop',

  OperationReportView = 'AuditHubOperationReportView',
  ClientAPIControlView = 'ClientAPIControlView',
  ClientAPIControlEdit = 'ClientAPIControlEdit',

  EnvironmentImport = 'EnvironmentImport',
  EnvironmentExport = 'EnvironmentExport',
}

export enum RbacRoleType {
  Owner = 'owner',
  Admin = 'admin',
  Editor = 'editor',
  Viewer = 'viewer',
  Custom = 'custom',
}

// 角色
export interface IRBACRole {
  readonly roleId: number;
  readonly roleName: string;
  readonly desc: string;
  readonly type: string;
  readonly createdAt: string;
  readonly updatedAt: string;
  readonly userList: string[];
  readonly permissions: string[];
}

export interface ICreateRoleBody {
  readonly name: string;
  readonly description: string;
  readonly permissions: string[];
  readonly studioID: string;
  readonly type: string;
  readonly userList: string[];
}

export interface IEditRoleBody {
  readonly name: string;
  readonly description: string;
  readonly permissions: string[];
  readonly studioID: string;
  readonly userList: string[];
}

// 用户组
export interface IUserGroupScopeItem {
  readonly gameId: string;
  readonly envId: number[] | 0;
}

export interface IRBACUserGroupRole {
  readonly roleId: number;
  readonly scope: ReadonlyArray<IUserGroupScopeItem> | 0;
}

export interface IRBACUserGroup {
  readonly groupId: number;
  readonly groupName: string;
  readonly desc: string;
  readonly roles: ReadonlyArray<IRBACUserGroupRole>;
  readonly members: ReadonlyArray<string>; // 用户ID数组,比如 ['a@tencent.com', 'b@tencent.com']
}

export interface IServicePermissionsGroupItem {
  readonly children: IServicePermissionsGroupItem[] | null;
  readonly objectGroupId: number;
  readonly objectGroupName: string;
  readonly objects: any[];
  readonly parentId: number;
  readonly sort?: number;
  // readonly id: number;
  // readonly parent_id: number;
  // readonly object_key: string;
  // readonly title: string;
}

export interface IServicePermissionsObjectItem {
  readonly objectGroupId: number;
  readonly objectId: number;
  readonly objectKey: string;
  readonly objectName: string;
}

export interface IServicePermissionsObjectTableItem {
  readonly children?: IServicePermissionsObjectTableItem[] | null;
  readonly objectGroupId: number;
  readonly objectId?: number;
  readonly objectKey?: string;
  readonly objectName?: string;
  readonly objectGroupName?: string;
  readonly objects?: any[];
  readonly parentId?: number;
  readonly key?: string;
}

export interface IServicePermissions {
  readonly objectGroup: Array<IServicePermissionsGroupItem>;
  readonly objects: Array<IServicePermissionsObjectItem>;
}

export interface ICreateGroupBody {
  readonly name: string;
  readonly description: string;
  readonly roles: IRBACUserGroupRole[];
  readonly members: string[];
  readonly studioID: string;
}

// export interface IEditGroupBody {
//   readonly name: string;
//   readonly description: string;
//   readonly roles: IRBACUserGroupRole[];
//   readonly members: string[];
//   readonly studioID: string;
// }

export interface IDeleteRoleBody {
  readonly studioID: string;
}

export enum RoleGroupType {
  Role = 'roleGroup',
  Group = 'userGroup',
}
